/* PR-2 #5: Extracted from main-product.liquid (was inline media-gallery slider init).
   Loaded via defer to keep parser unblocked. Pure JS — no Liquid templating. */
  (() => {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery) return;

    const desktopSlider = mediaGallery.querySelector('.product__media-list--desktop');
    const mobileSlider = mediaGallery.querySelector('.product__media-list--mobile');
    const defaultSlider = mediaGallery.querySelector('.product__media-list:not(.product__media-list--desktop):not(.product__media-list--mobile)');

    const getActiveSlider = () => {
      const isMobile = window.innerWidth <= 749;
      if (mobileSlider && isMobile) return mobileSlider;
      if (desktopSlider && !isMobile) return desktopSlider;
      if (defaultSlider) return defaultSlider;
      return null;
    };

    const thumbnailsSlider = mediaGallery.querySelector('[id^="GalleryThumbnails"]');

    const svgNext = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z" stroke="#ECEBDE"/>
      <path d="M17.5 26.6668L24.1667 20.0002L17.5 13.3335" stroke="#727270" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const svgPrev = `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" style="transform: rotate(180deg);">
      <path d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z" stroke="#ECEBDE"/>
      <path d="M17.5 26.6668L24.1667 20.0002L17.5 13.3335" stroke="#727270" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const prev = document.createElement('button');
    const next = document.createElement('button');
    prev.className = 'pdp-main-arrow pdp-main-arrow--prev';
    next.className = 'pdp-main-arrow pdp-main-arrow--next';
    prev.type = 'button';
    next.type = 'button';
    prev.innerHTML = svgPrev;
    next.innerHTML = svgNext;

    // Anchor the arrows to the <slider-component> that's currently visible.
    // In metafield mode, there are TWO slider-components (one for desktop,
    // one for mobile) — the inactive one is display:none, so anchoring to
    // the wrong one makes the arrows disappear. We pick dynamically and
    // re-place on resize.
    const placeArrows = () => {
      const slider = getActiveSlider();
      const target =
        (slider && slider.closest('slider-component')) ||
        mediaGallery.querySelector('slider-component:not(.thumbnail-slider)') ||
        mediaGallery.querySelector('slider-component') ||
        mediaGallery;
      if (prev.parentElement !== target) target.appendChild(prev);
      if (next.parentElement !== target) target.appendChild(next);
    };
    placeArrows();

    const getThumbnailItems = () => {
      if (!thumbnailsSlider) return [];
      return Array.from(thumbnailsSlider.querySelectorAll('.thumbnail-list__item'));
    };

    const getActiveIndex = (items) => items.findIndex((item) => item.querySelector('button')?.getAttribute('aria-current') === 'true');

    const getCurrentIndex = (slider) => {
      if (!slider) return 0;
      const slides = Array.from(slider.querySelectorAll('.product__media-item'));
      if (slides.length === 0) return 0;

      const scrollLeft = slider.scrollLeft;

      // Mobile-style horizontal scroll-snap: derive index from scrollLeft / slideWidth.
      // This is reliable across Dawn's default / metafield / thumbnail slider modes —
      // unlike the previous offsetLeft loop, which produced wonky values depending on
      // the slide's offset parent and led to both arrows being hidden on mobile.
      const sampleSlide = slides[0];
      const slideWidth = sampleSlide && sampleSlide.clientWidth ? sampleSlide.clientWidth : 0;
      if (slideWidth > 0) {
        const idx = Math.round(scrollLeft / slideWidth);
        return Math.min(slides.length - 1, Math.max(0, idx));
      }

      // Fallback: original offsetLeft scan
      let currentIndex = 0;
      for (let i = 0; i < slides.length; i++) {
        const slideLeft = slides[i].offsetLeft;
        if (scrollLeft >= slideLeft - 50) currentIndex = i;
        else break;
      }
      return currentIndex;
    };

    const getTotalSlides = (slider) => {
      if (!slider) return 0;
      return slider.querySelectorAll('.product__media-item').length;
    };

    const scrollToSlide = (slider, direction) => {
      if (!slider) return;
      const slides = Array.from(slider.querySelectorAll('.product__media-item'));
      if (slides.length === 0) return;
      const currentIndex = getCurrentIndex(slider);
      let targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
      if (targetIndex < 0) targetIndex = 0;
      if (targetIndex >= slides.length) targetIndex = slides.length - 1;
      const targetSlide = slides[targetIndex];
      if (targetSlide) {
        slider.scrollTo({ left: targetSlide.offsetLeft, behavior: 'smooth' });
      }
    };

    const updateArrowStates = () => {
      const isMobile = window.innerWidth <= 749;
      const activeSlider = getActiveSlider();

      if (!isMobile && thumbnailsSlider && getThumbnailItems().length > 0) {
        const items = getThumbnailItems();
        if (!items.length) {
          prev.style.opacity = '0';
          next.style.opacity = '0';
          return;
        }
        const current = getActiveIndex(items);
        prev.style.opacity = current <= 0 ? '0' : '1';
        prev.style.pointerEvents = current <= 0 ? 'none' : 'auto';
        next.style.opacity = current >= items.length - 1 ? '0' : '1';
        next.style.pointerEvents = current >= items.length - 1 ? 'none' : 'auto';
      } else if (activeSlider) {
        const totalSlides = getTotalSlides(activeSlider);
        const currentIndex = getCurrentIndex(activeSlider);
        prev.style.opacity = currentIndex <= 0 ? '0' : '1';
        prev.style.pointerEvents = currentIndex <= 0 ? 'none' : 'auto';
        next.style.opacity = currentIndex >= totalSlides - 1 ? '0' : '1';
        next.style.pointerEvents = currentIndex >= totalSlides - 1 ? 'none' : 'auto';
      } else {
        prev.style.opacity = '0';
        next.style.opacity = '0';
      }
    };

    prev.addEventListener('click', () => {
      const isMobile = window.innerWidth <= 749;
      const activeSlider = getActiveSlider();
      if (!isMobile && thumbnailsSlider && getThumbnailItems().length > 0) {
        const items = getThumbnailItems();
        if (!items.length) return;
        const current = getActiveIndex(items);
        const target = current - 1;
        if (target < 0) return;
        items[target].querySelector('button')?.click();
        setTimeout(updateArrowStates, 100);
      } else if (activeSlider) {
        scrollToSlide(activeSlider, 'prev');
        setTimeout(updateArrowStates, 200);
      }
    });

    next.addEventListener('click', () => {
      const isMobile = window.innerWidth <= 749;
      const activeSlider = getActiveSlider();
      if (!isMobile && thumbnailsSlider && getThumbnailItems().length > 0) {
        const items = getThumbnailItems();
        if (!items.length) return;
        const current = getActiveIndex(items);
        const target = current + 1;
        if (target >= items.length) return;
        items[target].querySelector('button')?.click();
        setTimeout(updateArrowStates, 100);
      } else if (activeSlider) {
        scrollToSlide(activeSlider, 'next');
        setTimeout(updateArrowStates, 200);
      }
    });

    if (thumbnailsSlider) {
      thumbnailsSlider.querySelectorAll('.thumbnail-list__item button').forEach((btn) => {
        btn.addEventListener('click', () => setTimeout(updateArrowStates, 100));
      });
    }

    const watchSliderScroll = () => {
      const activeSlider = getActiveSlider();
      if (activeSlider && !activeSlider._scrollListenerAdded) {
        activeSlider.addEventListener('scroll', () => {
          updateArrowStates();
        });
        activeSlider._scrollListenerAdded = true;
      }
    };

    const observer = new MutationObserver(() => {
      watchSliderScroll();
      updateArrowStates();
    });
    observer.observe(mediaGallery, { childList: true, subtree: true });

    window.addEventListener('resize', () => {
      // Re-place arrows on viewport change — the active slider-component
      // may switch between the desktop and mobile variants in metafield mode.
      placeArrows();
      setTimeout(updateArrowStates, 100);
    });

    setTimeout(() => {
      watchSliderScroll();
      updateArrowStates();
    }, 100);
  })();
